import * as React from "react";
const SvgFiRrRefundAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-refund-alt_svg__a)">
      <path
        fill="#062147"
        d="M18 7h2.666c-1.943-3.389-5.697-5.375-9.776-4.941-4.57.487-8.292 4.188-8.82 8.753C1.37 16.854 6.094 22 12 22c5.514 0 10-4.486 10-10a1 1 0 1 1 2 0c0 6.774-5.64 12.255-12.473 11.991C5.355 23.752.248 18.646.01 12.475-.256 5.642 5.226 0 12 0c4.104 0 7.805 2.034 9.995 5.345L22 3a1 1 0 1 1 2 0v3.991A2.01 2.01 0 0 1 21.991 9h-3.99a1 1 0 1 1 0-2m-6 12a1 1 0 0 0 1-1v-1c1.654 0 3-1.346 3-3 0-1.359-.974-2.51-2.315-2.733l-3.04-.506A.77.77 0 0 1 10 10c0-.552.45-1 1-1h2.268c.356 0 .688.191.867.501a.997.997 0 0 0 1.366.364 1 1 0 0 0 .364-1.366A3.01 3.01 0 0 0 13.267 7H13V6a1 1 0 1 0-2 0v1c-1.654 0-3 1.346-3 3 0 1.359.974 2.51 2.315 2.733l3.04.506A.77.77 0 0 1 14 14a1 1 0 0 1-1 1h-2.268c-.356 0-.688-.191-.867-.501a.997.997 0 0 0-1.366-.364 1 1 0 0 0-.365 1.366A3.01 3.01 0 0 0 10.731 17H11v1a1 1 0 0 0 1 1z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-refund-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRefundAlt;
